import React from 'react';
import { Globe, Phone, Mail, MessageSquare, Users, Database, GitBranch, Clock, Repeat, AlertTriangle, Zap, BookOpen } from 'lucide-react';

const BLOCK_CATEGORIES = [
  {
    label: 'Triggers',
    color: 'purple',
    blocks: [
      { id: 'webhook_trigger', label: 'Webhook', icon: Globe, type: 'trigger' },
      { id: 'db_trigger', label: 'DB Change', icon: Database, type: 'trigger' },
      { id: 'schedule_trigger', label: 'Schedule', icon: Clock, type: 'trigger' },
      { id: 'api_trigger', label: 'API Call', icon: Zap, type: 'trigger' },
    ]
  },
  {
    label: 'GoHighLevel',
    color: 'orange',
    blocks: [
      { id: 'ghl_create_contact', label: 'Create Contact', icon: Users, type: 'action' },
      { id: 'ghl_update_status', label: 'Update Status', icon: Globe, type: 'action' },
      { id: 'ghl_move_pipeline', label: 'Move Pipeline', icon: GitBranch, type: 'action' },
    ]
  },
  {
    label: 'AI Dialer',
    color: 'blue',
    blocks: [
      { id: 'dialer_add_queue', label: 'Add to Queue', icon: Phone, type: 'action' },
      { id: 'dialer_call', label: 'Initiate Call', icon: Phone, type: 'action' },
    ]
  },
  {
    label: 'Email (Resend)',
    color: 'green',
    blocks: [
      { id: 'email_send', label: 'Send Email', icon: Mail, type: 'action' },
      { id: 'email_campaign', label: 'Add to Campaign', icon: Mail, type: 'action' },
    ]
  },
  {
    label: 'SMS (Twilio)',
    color: 'red',
    blocks: [
      { id: 'sms_send', label: 'Send SMS', icon: MessageSquare, type: 'action' },
      { id: 'sms_sequence', label: 'SMS Sequence', icon: MessageSquare, type: 'action' },
    ]
  },
  {
    label: 'Logic',
    color: 'yellow',
    blocks: [
      { id: 'condition', label: 'Condition', icon: GitBranch, type: 'condition' },
      { id: 'delay', label: 'Delay Timer', icon: Clock, type: 'condition' },
      { id: 'loop', label: 'Loop', icon: Repeat, type: 'condition' },
      { id: 'error_handler', label: 'Error Handler', icon: AlertTriangle, type: 'condition' },
    ]
  },
];

const colorMap = {
  purple: 'bg-purple-50 border-purple-200 text-purple-700 hover:bg-purple-100',
  orange: 'bg-orange-50 border-orange-200 text-orange-700 hover:bg-orange-100',
  blue: 'bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100',
  green: 'bg-green-50 border-green-200 text-green-700 hover:bg-green-100',
  red: 'bg-red-50 border-red-200 text-red-700 hover:bg-red-100',
  yellow: 'bg-yellow-50 border-yellow-200 text-yellow-700 hover:bg-yellow-100',
};

const WorkflowToolbar = ({ onAddBlock, onOpenTemplates }) => {
  return (
    <div className="w-64 flex-shrink-0 bg-white border-r border-gray-200 overflow-y-auto">
      <div className="p-4 border-b border-gray-100">
        <h3 className="text-sm font-semibold text-gray-900">Automation Blocks</h3>
        <p className="text-xs text-gray-500 mt-0.5">Drag or click to add to canvas</p>
      </div>
      <div className="p-3 space-y-4">
        {BLOCK_CATEGORIES?.map(cat => (
          <div key={cat?.label}>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">{cat?.label}</p>
            <div className="space-y-1">
              {cat?.blocks?.map(block => (
                <button
                  key={block?.id}
                  onClick={() => onAddBlock?.(block)}
                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg border text-xs font-medium transition-colors ${colorMap?.[cat?.color]}`}
                >
                  <block.icon className="w-3.5 h-3.5 flex-shrink-0" />
                  {block?.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="p-3 border-t border-gray-100">
        <button
          onClick={onOpenTemplates}
          className="w-full flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-600 text-white text-xs font-medium hover:bg-blue-700 transition-colors"
        >
          <BookOpen className="w-3.5 h-3.5" />
          Browse Templates
        </button>
      </div>
    </div>
  );
};

export default WorkflowToolbar;
